import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}
    :host {
        display: inline-block;
        width: auto;
        cursor: pointer;
    }

    /* RESET */
    button {
        background: #fff;
        border: none;
        display: block;
        font-family: inherit;
        font-size: unset;
        font-size: unset;
        margin: 0;
        padding: 0;
    }

    /* BASE */

    .btn {
        display: inline-flex;
        align-items: stretch;
        justify-content: center;
        border-style: solid;
        font-family: var(--sgdf-input-font-family);
        font-weight: var(--sgdf-font-weight-semibold);
        border-width: var(--sgdf-input-border-width);
        border-color: #000;
        border-radius: var(--sgdf-border-radius-medium);
        cursor: pointer;
        overflow: hidden;
        padding: var(--sgdf-spacing-x-small) 0;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 100%;
        --btn-spacing-between: var(--sgdf-spacing-small);
        --btn-spacing-x-label: var(--sgdf-spacing-medium);
    }

    .btn-small {
        padding: var(--sgdf-spacing-2x-small) 0;
        --btn-spacing-between: var(--sgdf-spacing-x-small);
        --btn-spacing-x-label: var(--sgdf-spacing-small);
    }

    /* Clicks on icons shouldn't prevent the button from gaining focus */
    .btn::slotted(sgdf-icon) {
        pointer-events: none;
    }

    .btn-prefix,
    .btn-suffix {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
    }
    .btn-label ::slotted(sgdf-icon) {
        vertical-align: -2px;
    }

    /* MODES */
    .btn {
        background-color: var(--mode-color);
        border-color: var(--mode-color);
        color: #fff;
    }
    .btn-text {
        background-color: transparent;
        border-color: transparent;
        color: var(--sgdf-color-default);
    }

    .outlined {
        background-color: #fff;
        color: var(--mode-color);
        border-color: var(--mode-color);
    }

    /* STATES */
    .btn:enabled:focus {
        box-shadow: 0 0 0 0.2em rgba(50, 115, 220, 0.25);
        outline: 0;
    }

    .btn:enabled:hover {
        background-color: var(--mode-color-hover);
        color: #fff;
        box-shadow: 0 1px 3px #888;
    }

    .btn-text:enabled:hover {
        color: var(--sgdf-color-primary-500);
        background-color: transparent;
        box-shadow: none;
    }

    .btn:enabled:active {
        box-shadow: none;
        outline: 0;
    }

    button:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    /* When disabled, prevent mouse events from bubbling up */
    .btn-disabled * {
        pointer-events: none;
    }

    /* TRANSITIONS */
    .btn {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transition:
            var(--sgdf-transition-fast) background-color,
            var(--sgdf-transition-fast) color,
            var(--sgdf-transition-fast) border,
            var(--sgdf-transition-fast) box-shadow;
    }

    /** LOADING */

    .loading {
        position: relative;
        cursor: wait;
    }
    .loading .btn-prefix,
    .loading .btn-label,
    .loading .btn-suffix {
        visibility: hidden;
    }
    .loading sgdf-spinner {
        --track-color: currentColor;
        --track-width: 5px;
        position: absolute;
        font-size: 1em;
        height: 1em;
        width: 1em;
        top: calc(50% - 0.5em);
        left: calc(50% - 0.5em);
    }

    /** SPACING */

    .btn--has-label .btn-label {
        padding: 0 var(--btn-spacing-x-label);
    }

    .btn--has-prefix {
        padding-left: var(--btn-spacing-between);
    }

    .btn--has-prefix .btn-label {
        padding-left: var(--btn-spacing-between);
    }

    .btn--has-suffix {
        padding-right: var(--btn-spacing-between);
    }

    .btn--has-suffix .btn-label {
        padding-right: var(--btn-spacing-between);
    }
`;
//# sourceMappingURL=button.styles.js.map